<template>
  <div class="editorImageSection">
    <div :class="['editorImageSection__inner', `editorImageSection__inner--${data.direction}`]">
      <div class="editorImageSection__image">
        <img :src="data.image" alt="" />
      </div>
      <div class="editorImageSection__content">
        <p v-html="data.text" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditorImageSection',
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss">
.editorImageSection {
  $root: &;

  &__inner {
    display: flex;
    flex-wrap: wrap;
    margin-left: -1.2rem;
    margin-right: -1.2rem;
    flex-direction: row-reverse;

    &--left {
      flex-direction: row;

      @include rwd('tablet') {
        flex-direction: row;
      }

      #{$root}__content {
        padding-left: 3.5rem;
        padding-right: 1.2rem !important;

        @include rwd('tablet') {
          padding-left: 1.2rem;
        }
      }

      #{$root}__image {
        padding-left: 1.2rem;
      }
    }
  }

  &__content {
    flex: 0 0 50%;
    max-width: 50%;
    padding-right: 4rem;
    padding-left: 1.2rem;

    @include rwd('tablet') {
      flex: 0 0 100%;
      max-width: 100%;
      padding-right: 1.2rem;
      order: 1;
    }

    p {
      margin-bottom: 2rem;
      font-size: 1.6rem;
      line-height: 2.4rem;
      color: $cAddDark02;
    }

    b,
    strong {
      font-weight: 700;
      color: $cMainLight;
    }

    a {
      color: $cSec;
      transition: color $tr;

      &:hover {
        color: $cSecHover;
      }
    }
  }

  &__image {
    flex: 0 0 50%;
    max-width: 50%;
    padding-left: 3.5rem;
    padding-right: 1.2rem;

    @include rwd('tablet') {
      order: 2;
      margin-top: 1rem;
      display: flex;
      flex: 0 0 100%;
      max-width: 100%;
      justify-content: center;
      padding-left: 1.2rem;
    }

    img {
      max-width: 100%;
    }
  }
}
</style>
